import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xwgv2hs87j: FaireBrandEntity = {
  token: "b_xwgv2hs87j",
  type: "brand",
  name: "Leeada Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/4810c342abe8dcf147c31c16ef3d2e39357d9f5056a9771c310ca5cb9ee0329d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e56cad93bbf3fe48fed51e6a2fc95648294ca9039513ea84ce0eb84e6ebec8cb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4810c342abe8dcf147c31c16ef3d2e39357d9f5056a9771c310ca5cb9ee0329d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e56cad93bbf3fe48fed51e6a2fc95648294ca9039513ea84ce0eb84e6ebec8cb.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 350,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "LEEADA Jewelry started as an idea by gemstone devotees desiring a space for jewelry between fashion and heirloom.\n\nStyles that are on trend, but not trendy, youthful but mature, and seemingly effortless and aspiring.\n\nOur collections reflect pieces that evoke a spirit that glides gracefully through the seasons, unbeholden by a calendar ~ a spirit much like our beloved City of Angels where the line was first imagined.\n\nWhen our pieces speak to you, they should say: we love you, we are yours. We are proudly women-owned, and operated, and worn by anyone and everyone who loves jewelry as much as we do.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:20.646Z",
    importedBy: "entity-db-cli",
  },
};
